import { MerchantFeature } from "@redotech/cockroachdb-codegen/tables/internal-ops/merchant-feature";
import { MerchantPausedFeatureSchema } from "@redotech/redo-merchant-pause-common/paused-feature";
import { merchantPausedFeatureIdFormat } from "@redotech/redo-merchant-pause-id";
import * as z from "zod";

export const getMerchantPausedFeatures = {
  name: "getMerchantPausedFeatures" as const,
  input: z.object({ teamId: z.string(), feature: z.enum(MerchantFeature) }),
  output: z.object({ pauses: z.array(MerchantPausedFeatureSchema) }),
};

export const pauseMerchantFeature = {
  name: "pauseMerchantFeature" as const,
  input: z.object({
    teamId: z.string(),
    feature: z.enum(MerchantFeature),
    startsAt: z.date().optional(),
    endsAt: z.date(),
    reason: z.string().trim().max(500).optional(),
  }),
  output: z.object({ pause: MerchantPausedFeatureSchema }),
};

export const endMerchantFeaturePause = {
  name: "endMerchantFeaturePause" as const,
  input: z.object({
    teamId: z.string(),
    pauseId: merchantPausedFeatureIdFormat.schema,
  }),
  output: z.object({ result: z.enum(["ended", "cancelled"]) }),
};
